var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 5.96762V18.5769C28 19.75 27.5391 20.875 26.7186 21.7045C25.8981 22.534 24.7853 23 23.625 23H4.375C3.21468 23 2.10188 22.534 1.28141 21.7045C0.460936 20.875 0 19.75 0 18.5769V5.96762L13.5555 14.0318C13.6902 14.1121 13.8437 14.1544 14 14.1544C14.1563 14.1544 14.3098 14.1121 14.4445 14.0318L28 5.96762ZM23.625 5.47624e-08C24.7015 -0.000171113 25.7403 0.400919 26.5426 1.12654C27.3449 1.85216 27.8545 2.85137 27.9738 3.933L14 12.2431L0.0262502 3.933C0.145527 2.85137 0.655067 1.85216 1.45739 1.12654C2.25972 0.400919 3.29849 -0.000171113 4.375 5.47624e-08H23.625Z",
    fill: "#2DB0D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.d1b68db4e5ee441ae5fa91975f470d60.svg";
export { ForwardRef as ReactComponent };